import React from 'react';
import { Code } from 'lucide-react';

export default function HTMLHero() {
  const scrollToGenerator = () => {
    document.getElementById('html-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1461749280684-dccba630e2f6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          alt="Code editor with HTML"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 opacity-85"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="flex justify-center mb-6">
          <Code className="w-16 h-16 text-blue-400 animate-pulse" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          AI HTML Generator
        </h1>
        <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
          Generate clean, semantic HTML code instantly with our AI-powered tool.
          Perfect for developers, designers, and web creators of all skill levels.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <span className="bg-blue-700/50 px-4 py-2 rounded-full text-white text-sm border border-blue-500/30">
            Semantic HTML
          </span>
          <span className="bg-blue-700/50 px-4 py-2 rounded-full text-white text-sm border border-blue-500/30">
            Responsive Design
          </span>
          <span className="bg-blue-700/50 px-4 py-2 rounded-full text-white text-sm border border-blue-500/30">
            Best Practices
          </span>
        </div>
        <button 
          onClick={scrollToGenerator}
          className="bg-blue-500 text-white text-lg px-8 py-4 rounded-lg hover:bg-blue-600 transition-all cursor-pointer transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 mx-auto"
        >
          <Code className="w-5 h-5" />
          Generate HTML Code
        </button>
        <p className="mt-6 text-sm text-blue-200 bg-blue-800/30 inline-block px-4 py-2 rounded-full mx-auto">
          Trusted by over 50,000+ developers worldwide
        </p>
      </div>
    </div>
  );
}